export {default as zoom} from "./src/zoom";
export {default as zoomTransform, identity as zoomIdentity} from "./src/transform";



//////////////////
// WEBPACK FOOTER
// ./~/d3-zoom/index.js
// module id = 303
// module chunks = 0